import { Component, TemplateRef, ViewChild, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'iot-platform-ui-drag-drop-meta',
  changeDetection: ChangeDetectionStrategy.Eager,
  template: `
    <ng-template>
      <ng-content />
    </ng-template>
  `
})
export class DragDropMetaComponent {
  @ViewChild(TemplateRef, { static: true }) public template!: TemplateRef<unknown>;
}
